import React from 'react';
import { View, StyleProp, ViewStyle } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';

export const JEWELRY_METAL_HEX: Record<string, string> = {
  gold: '#FFD700',
  silver: '#AAA9AD',
  bronze: '#CD7F32',
  rosegold: '#E8B4B8',
};

export const JEWELRY_METAL_GRADIENTS: Record<string, string[]> = {
  gold: ['#FFD700', '#FFA500', '#FFD700', '#FF8C00', '#FFD700'],
  silver: ['#FFFFFF', '#C0C0C0', '#E6E6E6', '#A8A8A8', '#D3D3D3'],
  bronze: ['#CD7F32', '#B87333', '#CD7F32', '#A0522D', '#CD7F32'],
  rosegold: ['#E8B4B8', '#F4A6A6', '#E8B4B8', '#D4A5A5', '#E8B4B8'],
};

function normalizeJewelryKey(key: string): string {
  return key.toLowerCase().replace(/[\s_-]+/g, '');
}

export function getJewelryMetalHex(key: string): string | undefined {
  return JEWELRY_METAL_HEX[normalizeJewelryKey(key)];
}

export function getJewelryMetalGradient(
  key: string
): string[] | undefined {
  return JEWELRY_METAL_GRADIENTS[normalizeJewelryKey(key)];
}

interface JewelryMetalSwatchProps {
  jewelryKey: string;
  hex: string;
  style?: StyleProp<ViewStyle>;
  borderColor?: string;
}

export default function JewelryMetalSwatch({
  jewelryKey,
  hex,
  style,
  borderColor,
}: JewelryMetalSwatchProps) {
  const gradientColors = getJewelryMetalGradient(jewelryKey);
  const borderStyle = {
    borderWidth: 1,
    borderColor: borderColor ?? 'transparent',
    overflow: 'hidden' as const,
  };

  if (gradientColors) {
    return (
      <LinearGradient
        colors={gradientColors}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={[style, borderStyle]}
      />
    );
  }

  return (
    <View style={[style, borderStyle, { backgroundColor: hex }]} />
  );
}
